import React from 'react'
import styled from 'styled-components'

import Logo from "../../../images/logos/submittable-logo-b.png"
import WhiteLogo from "../../../images/logos/submittable-logo-w.png"
import Event from "../../util/GAEvent"
import Link from "../../util/link"

const LogoLink = styled(Link)`
  img {
      height: 23px;
  }
`

export default ({darkMode}) => (
    <LogoLink to="/">
        <Event action="Clicked Navbar Logo" label='/'>
            <img
                className="logo"
                src={darkMode ? WhiteLogo : Logo}
                alt="submittable link to home"
                title="Submittable Link to Home"
            />
        </Event>
    </LogoLink>
)